import React from 'react';
import { observer } from 'mobx-react';
import { Typography, Chip } from '@execonline-inc/execonline-ui';

interface Props {
  children: React.ReactNode;
}

function ExperienceProductLabel({ children }: Props) {
  return (
    <Chip className="bg-muted/50">
      <Typography className="flex items-center gap-x-2 text-foreground" variant="caption">
        {children}
      </Typography>
    </Chip>
  );
}

export default observer(ExperienceProductLabel);
